import { useEffect, useState } from 'react';
import { App } from 'antd';
import MasterPackageService from 'services/master/package';

const service = new MasterPackageService();

const useComponent = () => {
  const { message, modal } = App.useApp();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState(null); // request_id being approved

  const load = async () => {
    setLoading(true);
    try {
      const result = await service.listPending();
      setData(Array.isArray(result) ? result : []);
    } catch {
      message.error('Không thể tải danh sách yêu cầu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onApprove = (record) => {
    modal.confirm({
      title: `Xác nhận kích hoạt gói ${record.package_name}?`,
      content: `Shop: ${record.workspace?.web_site?.title || record.w_id} — Số tiền: ${record.amount?.toLocaleString('vi-VN')}đ`,
      okText: 'Kích hoạt',
      cancelText: 'Hủy',
      onOk: async () => {
        setApproving(record.id);
        try {
          await service.approve({ request_id: record.id });
          message.success('Đã kích hoạt gói thành công');
          load();
        } catch (err) {
          message.error(err?.message || 'Kích hoạt thất bại');
        } finally {
          setApproving(null);
        }
      },
    });
  };

  return {
    data,
    loading,
    approving,
    onApprove,
    reload: load,
  };
};

export default useComponent;
